import { createSlice } from "@reduxjs/toolkit";
import { getUserInfo } from "./_contactSupportAction";


interface ManageContactSupportState {
  contactSupportData: {};
  loading: boolean;
  error: string | null;
}

const initialState: ManageContactSupportState = {
  contactSupportData: {},
  loading: false,
  error: null,
};


export const contactSupportReducer = createSlice({
  name: "contactSupport",
  initialState: initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch help center data
      .addCase(getUserInfo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUserInfo.fulfilled, (state, action) => {
        state.loading = false;
        state.contactSupportData = action.payload?.data;
      })
      .addCase(getUserInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
  },
});


export const { clearError } = contactSupportReducer.actions;
export default contactSupportReducer;